import { useTheme } from "styled-components";
import Flex from "common/Boxes/Flex.tsx";
import React, { CSSProperties, MouseEvent, PropsWithChildren } from "react";
import DisconnectOutlined from "@ant-design/icons/DisconnectOutlined";
import Tooltip from "common/Tooltips/Tooltip.tsx";
import Text from "common/Typography/Text.tsx";

interface InactiveGroupIconProps extends PropsWithChildren {
  isInactive?: boolean;
  style?: CSSProperties;
}

const InactiveGroupIcon = ({
  isInactive,
  style,
  children,
}: InactiveGroupIconProps) => {
  const theme = useTheme();
  const validColor = theme.colors.primaryText;
  const invalidColor = theme.colors.darkYellow;

  const content = (
    <Flex
      $justifyContent="flex-start"
      style={{
        color: isInactive ? invalidColor : validColor,
        ...style,
      }}
      onClick={(e: MouseEvent) => {
        if (isInactive) {
          e.stopPropagation();
        }
      }}
    >
      {children}
      {isInactive && (
        <DisconnectOutlined style={{ color: invalidColor, marginLeft: 6 }} />
      )}
    </Flex>
  );

  const title =
    "This bot is connected to a group that is no longer active, new trades will not open.";

  if (isInactive) {
    return (
      <Tooltip
        title={<Text style={{ color: "inherit" }}>{title}</Text>}
        showMobileBottomDrawer={true}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default InactiveGroupIcon;
